import { FieldType } from "@/typings/model";

export function convertFieldListToOption(fieldList: Array<FieldType>) {
  const filteredFieldList = fieldList.filter(
    (field) => field.type !== "STRING"
  );
  return filteredFieldList.map((field) => ({
    label: field.name,
    value: field.id,
  }));
}
